import { render, staticRenderFns } from "./PlantillaEdit.vue?vue&type=template&id=8bf7d6fc&scoped=true"
import script from "./PlantillaEdit.vue?vue&type=script&lang=js"
export * from "./PlantillaEdit.vue?vue&type=script&lang=js"
import style0 from "./PlantillaEdit.vue?vue&type=style&index=0&id=8bf7d6fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf7d6fc",
  null
  
)

export default component.exports